import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AgreementService } from '../../shared/services/apis/platform/agreement.service';
import { AgreementStruct } from '../../shared/services/requests/platform/upload-livro.request';
import { AgreementResponseStruct } from '../../shared/services/responses/platform/agreement.response';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-agreement-modal',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule
    ],
    templateUrl: './agreement-modal.component.html',
    styleUrls: ['./agreement-modal.component.css']
})
export class AgreementModalComponent implements OnInit {
    listAgreement: (AgreementResponseStruct & AgreementStruct & { safePdfUrl: SafeResourceUrl })[] = [];
    loading = true;
    error = '';

    constructor(
        public dialogRef: MatDialogRef<AgreementModalComponent>,
        @Inject(MAT_DIALOG_DATA) public idStatusVersion: number,
        private agreementService: AgreementService,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        this.allMandatoryAccepted();
        this.agreementService.getByStatusVersion(this.idStatusVersion).subscribe({
            next: (res) => {
                if (!res.listAgreementResponseStruct || res.listAgreementResponseStruct.length === 0) {
                    this.dialogRef.close([]); // Nenhum termo — fecha o modal retornando lista vazia
                    return;
                }

                this.listAgreement = res.listAgreementResponseStruct.map(a => ({
                    ...a,
                    agreementAccept: false,
                    safePdfUrl: this.sanitizer.bypassSecurityTrustResourceUrl(a.agreementPDFUrl)
                }));
                this.loading = false;
            },
            error: () => {
                this.error = 'Erro ao carregar os termos.';
                this.loading = false;
            }
        });
        this.allMandatoryAccepted();
    }

    allMandatoryAccepted(): boolean {
        return this.listAgreement
            .filter(a => a.isMandatory)
            .every(a => a.agreementAccept);
    }

    confirm(): void {
        const result: AgreementStruct[] = this.listAgreement.map(a => ({
            idAgreement: a.idAgreement,
            agreementAccept: a.agreementAccept
        }));
        this.dialogRef.close(result);
    }

    close(): void {
        this.dialogRef.close(null);
    }
}
